const freeBets = {
    en: {
        freeBetsTitle: "FREE BETS MANAGEMENT",
        playWithCash: "Play with cash",
        activeFreeBets: "ACTIVE FREE BETS",
        archive: "Archive",
        noActive: "No Active Free Bets. Yet!",
        back: "Back",
        nothingYet: "Nothing yet",
    },
    ru: {
        freeBetsTitle: "УПРАВЛЕНИЕ БЕСПЛАТНЫМИ СТАВКАМИ",
        playWithCash: "Играть на деньги",
        activeFreeBets: "АКТИВИРОВАТЬ БЕСПЛАТНЫЕ СТАВКИ",
        archive: "Архив",
        noActive: "Активных бесплатных ставок нет. Пока еще!",
        back: "Назад",
        nothingYet: "Пока ничего",
    },
    uz: {
        freeBetsTitle: "BEPUL PUL TIKISH MENEJMENTI",
        playWithCash: "Pul bilan oʻynash",
        activeFreeBets: "FAOL BONUS PUL TIKISHLAR",
        archive: "Arxiv",
        noActive: "Faol bonus pul tikish yoʻq. Hozircha!",
        back: "Orqaga",
        nothingYet: "Hech narsa yoʻq",
    }
}

export default freeBets;